const useProps = {
  context: {
    type: [Object, Array, Boolean],
    required: true,
    default: () => ({})
  },
  options: {
    type: Object,
    required: false,
    default: () => ({})
  }
};
export { useProps };
